import React, { useState } from "react";

import {
  Container,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Button,
} from "reactstrap";

import "./App.css";

function App() {
  const [adjustments, setAdjustments] = useState(false);
  const [fullName, setFullName] = useState(null);
  const [email, setEmail] = useState(null);
  const [topic, setTopic] = useState(null);
  const [issueDate, setIssueDate] = useState(null);
  const [complaintDescription, setComplaintDescription] = useState(null);
  const [adjustmentDescription, setAdjustmentDescription] = useState(null);

  const onAdjustmentsClick = (checked, value) => {
    if (checked && value === "YES") {
      setAdjustments(true);
    } else {
      setAdjustments(false);
    }
  };

  const onTopicSelect = (value) => {
    setTopic(value);
  };

  const onSubmitClick = () => {
    if (!fullName) {
      alert("Please enter your full name.");
    } else if (!email) {
      alert("Please enter a valid email address.");
    } else if (!validateEmail(email)) {
      alert("Please enter a valid email address.");
    } else if (!topic) {
      alert("Please select a topic.");
    } else if (!complaintDescription) {
      alert("Please describe your complaint.");
    } else if (adjustments && !adjustmentDescription) {
      alert("Please describe the required adjustments.");
    } else {
      alert(
        "Thank you for lodging your complaint with us. Be assured that we are committed to promptly and effectively addressing your concerns. Our team will thoroughly assess your complaint and will contact you as soon as possible."
      );
    }
  };

  const onFullNameEnter = (value) => {
    setFullName(value);
  };
  const onEmailEnter = (value) => {
    setEmail(value);
  };
  const onIssueDate = (value) => {
    setIssueDate(value);
  };
  const onComplaintDescriptionEnter = (value) => {
    setComplaintDescription(value);
  };
  const onDescirbeAdjustmentEnter = (value) => {
    setAdjustmentDescription(value);
  };

  const validateEmail = (emailId) => {
    const rex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (rex.test(emailId) === false) return false;
    else return true;
  };
  return (
    <Container fluid>
      <div className="form-layout">
        <Form>
          <FormGroup>
            <div className="complaint-header">
              <Label for="complaintForm">
                <h1>
                  <strong>Complaint Form</strong>
                </h1>
              </Label>
            </div>
            <Label>
              <h6>If any aspect of your experience with us has not met our high
              standards, please let us know. We recognize that we are not
              flawless, but we are committed to learning and improving from our
              mistakes. Your complaint will be promptly, fairly, and efficiently
              addressed to ensure a swift resolution.</h6>
            </Label>
            <div>
              <Label>
                <strong>1. </strong>Complaints regarding any element of the
                service provided by us can be sent to customer services via our
                app chat system or via email at <a href="support@healthmoni.com.">support@healthmoni.com.</a> 
              </Label>
              <Label>
                <strong>2. </strong> All complaints will be subject to our
                complaints procedure. We will provide you with a copy of our
                complaints procedure upon request and, if we receive a complaint
                from you, a copy of our complaints procedure will automatically
                be posted or emailed to you.
              </Label>
              <Label>
                <strong>3. </strong> In most cases we will provide a full
                response by email to your complaint within fifteen (15) Business
                Days after the date we receive your complaint. In exceptional
                circumstances where we are unable to respond in full to your
                complaint, we will inform you of this giving our reasons for the
                delay and the timeframe within which you will receive a full
                reply, which in any event shall be within thirty-five (35)
                Business Days of the date we received your complaint.
              </Label>
              <Label>
                <strong>4. </strong> If we fail to resolve your complaint to
                your satisfaction you may refer your complaint to the Financial
                Ombudsman Service (Exchange Tower, London E14 9SR, phone 0800
                023 4567). Details of the service offered by the Financial
                Ombudsman Service are available at 
                <a href="https://www.financial-ombudsman.org.uk"> https://www.financial-ombudsman.org.uk</a>
              </Label>
            </div>
          </FormGroup>
          <FormGroup>
            <Label for="fullName">
              <strong>Full Name</strong>
            </Label>
            <Input
              id="fullName"
              name="name"
              placeholder="Type your full name here"
              type="name"
              onChange={(e) => onFullNameEnter(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label for="email">
              <strong>Email Address</strong>
            </Label>
            <br></br>
            <FormText>
              Kindly provide the email address registered in HealthMoni. This
              information is essential for locating your account and addressing
              your complaint effectively. If you do not have an account, please
              share your preferred email address.
            </FormText>
            <Input
              id="email"
              name="email"
              placeholder="Type your email address"
              type="email"
              onChange={(e) => onEmailEnter(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label for="select">
              <strong>What is the topic for your complaint?</strong>
            </Label>
            <Input
              id="select"
              name="select"
              type="select"
              value={topic ? topic : "1"}
              onChange={(e) => onTopicSelect(e.target.value)}
            >
              <option value="1" disabled>
                Select Topic
              </option>
              <option>Data Security</option>
              <option>⁠⁠Fraud/unauthorized payment</option>
              <option>Onboarding</option>
              <option>KYC</option>
              <option>⁠Restricted Account</option>
              <option>Payment Request</option>
              <option>Transfer - inbound</option>
              <option>Transfer - outbound</option>
              <option>Technical Issue/Bug</option>
              <option>Other</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="selectDate">
              <strong>When did the issue first happen?</strong>
            </Label>
            <Input
              id="date"
              name="date"
              placeholder="date placeholder"
              type="date"
              onChange={(e) => onIssueDate(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label for="complaintText">
              <strong>Describe your complaint</strong>
            </Label>
            <Input
              id="complaintText"
              name="text"
              type="textarea"
              onChange={(e) => onComplaintDescriptionEnter(e.target.value)}
            />
          </FormGroup>
          {/* <FormGroup>
            <Label for="uploadFile">Upload File (Optional)</Label>
            <Input id="uploadFile" name="file" type="file" />
            <FormText>
              This is an optional field - please limit your upload to 3 files
              and do not exceed a total file size of 10MB. Also, avoid adding
              identifying information such as social security, address, date of
              birth, etc
            </FormText>
          </FormGroup> */}
          <FormGroup tag="fieldset">
            <strong>
              Do you require any adjustments to our complaint resolution
              process?
            </strong>
            <br></br>
            <FormText>
              (Let us know if you need adjustments on our end due to any
              vulnerabilities or special needs.)
            </FormText>
            <br></br>
            <FormGroup check>
              <Input
                name="radio1"
                type="radio"
                onChange={(e) => onAdjustmentsClick(e.target.checked, "YES")}
              />{" "}
              <Label check>Yes</Label>
            </FormGroup>
            <FormGroup check>
              <Input
                name="radio1"
                type="radio"
                checked={adjustments ? false : true}
                onChange={(e) => onAdjustmentsClick(e.target.checked, "NO")}
              />{" "}
              <Label check>No</Label>
            </FormGroup>
          </FormGroup>
          {adjustments && (
            <FormGroup>
              <Label for="complaintText">
                Describe the required adjustments
              </Label>
              <Input
                id="complaintText"
                name="text"
                type="textarea"
                onChange={(e) => onDescirbeAdjustmentEnter(e.target.value)}
              />
            </FormGroup>
          )}
          <div className="submit-button">
            <Button color="primary" onClick={onSubmitClick}>
              Submit
            </Button>
          </div>
        </Form>
      </div>
    </Container>
  );
}

export default App;
